import { render, staticRenderFns } from "./BisnodeViewer.vue?vue&type=template&id=00b81240&scoped=true&"
import script from "./BisnodeViewer.vue?vue&type=script&lang=js&"
export * from "./BisnodeViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b81240",
  null
  
)

export default component.exports